module.exports = __webpack_public_path__ + "static/media/Moon Bunny.5298f4c0.mp4";